<div class="relative flex flex-col flex-auto min-w-0 overflow-hidden">
    <div class="flex flex-col flex-auto px-2 sm:px-1">
        <div class="w-full max-w-3xl">
            <ng-container *ngIf="!isLoading; else loading">
                <ng-container *ngIf="activities.length > 0; else noActivity">
                    <div>
                        <ol>
                            <ng-container *ngFor="let activity of activities; let i = index; let first = first; let last = last; trackBy: trackByFn">
                                <ng-container *ngIf="first || !isSameDay(activity.createdDate, activities[i - 1].createdDate)">
                                    <li class="relative flex py-1 underline">
                                        <div class="relative py-2 px-2 text-md font-medium leading-5 ">
                                            {{getRelativeFormat(activity.createdDate) | titlecase}}
                                        </div>
                                    </li>
                                </ng-container>
                                <li class="relative flex py-3">
                                    <ng-container *ngIf="!last && isSameDay(activity.createdDate, activities[i + 1].createdDate)">
                                        <div class="absolute top-7 left-5 w-0.5 h-full -ml-px bg-gray-300 dark:bg-gray-600"></div>
                                    </ng-container>

                                    <div class="relative flex flex-auto">
                                         <div [matTooltip]="activity.createdBy | fullName"
                                            [innerHTML]="(activity['innerDiv'])">
                                                {{activity?.createdBy | fullName}}
                                         </div>
                                        <div class="flex flex-col flex-auto items-start">
                                            <ng-container *ngIf="activity.createdBy">
                                                <div><strong>
                                                    {{activity.createdBy | fullName}}
                                                </strong>{{util.getDescription(activity)}}<strong *ngIf="activity.actionType == 'ITEM_SHARED'"> {{activity.actionOutcome}}</strong></div>
                                            </ng-container>
                                            <div class="flex flex-col sm:flex-row sm:items-center mt-2 sm:mt-1 sm:space-x-2 text-md leading-5">
                                                <div class="text-secondary">
                                                    {{activity.createdDate  | date:'MMM dd, h:mm a'}}
                                                </div>
                                            </div>
                                            <ng-container *ngIf="activity.actionType && activity.actionType.includes('LABEL_')">
                                                <div class="flex flex-wrap items-center justify-start -mx-1 ml-1"  *ngIf="activity.actionOutcome">
                                                    <ng-container>
                                                        <div
                                                            class="asset-label m-1 py-0.5 px-2.5 rounded-full text-sm font-medium whitespace-nowrap no-select"
                                                            [ngClass]="util.getLabelCol(activity.actionOutcome)+'mt-4 py-2 px-2 rounded-lg bg-gray-200 dark:bg-gray-800'">
                                                            {{activity.actionOutcome}}
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </li>
                            </ng-container>
                        </ol>
                    </div>
                </ng-container>
            </ng-container>

            <ng-template #loading>
                    <div class="p-4">
                        <div
                            class="flex flex-auto flex-col items-center justify-center h-100 min-h-100 max-h-400 border-2 border-dashed border-gray-300 rounded-2xl bg-gray-100 dark:bg-transparent">
                            <div class="mt-4 text-2xl font-semibold tracking-tight text-secondary">Loading...</div>
                        </div>
                    </div>
            </ng-template>

            <ngx-loading [show]="isLoading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
            <ng-template #noActivity>
                <div class="p-4">
                    <div
                        class="flex flex-auto flex-col items-center justify-center h-100 min-h-100 max-h-400 border-2 border-dashed border-gray-300 rounded-2xl bg-gray-100 dark:bg-transparent">
                        <mat-icon class="icon-size-24" [svgIcon]="'heroicons_outline:folder-open'"></mat-icon>
                        <div class="mt-4 text-2xl font-semibold tracking-tight text-secondary">No items to display</div>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>
